module.exports = __webpack_public_path__ + "static/media/download.f3a16bee.svg";